import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import CategorySection from '@/pages/home/components/CategorySection';
import GuideSection from '@/pages/home/components/GuideSection';
import ArticleSection from '@/pages/home/components/ArticleSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <GuideSection />
        <ArticleSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}